<template>
  <div class="home-skeleton">
    <div class="item" v-for="i in 8" :key="i" :style="{ backgroundColor: bg }">
      <shSkeleton bg="#e4e4e4" width="255px" height="190px" animated />
      <shSkeleton bg="#e4e4e4" width="235px" height="45px" animated />
      <shSkeleton bg="#e4e4e4" width="185px" height="24px" animated />
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeSkeleton",
  props: {
    bg: {
      type: String,
      default: "#fff",
    },
  },
};
</script>

<style scoped lang="less">
.home-skeleton {
  width: 1040.75px;
  height: 600px;
  display: flex;
  flex-wrap: wrap;
  margin-left: 7px;
  margin-top: 10px;
  justify-content: space-between;

  .item {
    width: 255px;
    height: 300px;
    //margin-bottom: 8px;
    .sh-skeleton ~ .sh-skeleton {
      display: block;
      margin: 8px auto 0;
    }
  }
}
</style>
